var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { MeetEventActionEnum } from '@workalizer/shared';
export var MEET_TIMELINE_EVENT_ACTIONS = [
    MeetEventActionEnum.MEET_CALL_ENDED,
    MeetEventActionEnum.MEET_PRESENTATION_STARTED,
    MeetEventActionEnum.MEET_PRESENTATION_STOPPED,
    MeetEventActionEnum.MEET_KNOCKING_ACCEPTED,
    MeetEventActionEnum.MEET_KNOCKING_DENIED,
    MeetEventActionEnum.MEET_TRANSCRIPTION_ACTIVITY
];
export var calculateUserActivities = function (userEvents) {
    return Array.from(userEvents.values()).map(function (_a) {
        var user = _a.user, events = _a.events;
        var callEndedEvent = events.find(function (e) { return e.action === MeetEventActionEnum.MEET_CALL_ENDED; });
        var joinTime = callEndedEvent
            ? new Date(callEndedEvent.date.getTime() -
                (callEndedEvent.durationSeconds || 0) * 1000)
            : null;
        var presentationCount = events.filter(function (e) { return e.action === MeetEventActionEnum.MEET_PRESENTATION_STARTED; }).length;
        return {
            user: user,
            joinTime: joinTime,
            leaveTime: (callEndedEvent === null || callEndedEvent === void 0 ? void 0 : callEndedEvent.date) || null,
            duration: (callEndedEvent === null || callEndedEvent === void 0 ? void 0 : callEndedEvent.durationSeconds) || 0,
            presentationCount: presentationCount,
            events: events.map(function (event) { return (__assign(__assign({}, event), { date: event.date.toISOString() })); })
        };
    });
};
export var createTimelineData = function (event, user) {
    if (MEET_TIMELINE_EVENT_ACTIONS.includes(event.action)) {
        return {
            name: event.date,
            time: new Date(event.date).getTime(),
            user: user.name || user.email,
            type: event.action
        };
    }
    return undefined;
};
export var createUserEventsMap = function (meetingEvents) {
    var userEvents = new Map();
    meetingEvents.forEach(function (event) {
        var _a;
        if (!userEvents.has(event.userId)) {
            userEvents.set(event.userId, {
                user: event.user,
                events: []
            });
        }
        (_a = userEvents.get(event.userId)) === null || _a === void 0 ? void 0 : _a.events.push({
            id: event.id,
            date: event.date,
            action: event.action,
            durationSeconds: event.durationSeconds
        });
    });
    return userEvents;
};
